import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import {
  cloneValue,
  expectObject,
  readOptionalNumber,
  splitKnown,
} from "../utils";

export class ProductVersionShippingPriceModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    cad: { label: "CAD", fieldType: "number", allowNull: true },
    usd: { label: "USD", fieldType: "number", allowNull: true },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  cad!: number | null;
  usd!: number | null;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("cad", null);
    this.defineObservableValue("usd", null);
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product shipping price");
    this.cad = readOptionalNumber(source, "cad");
    this.usd = readOptionalNumber(source, "usd");
    this.extra = splitKnown(source, ["cad", "usd"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.cad === null ? {} : { cad: this.cad }),
      ...(this.usd === null ? {} : { usd: this.usd }),
    };
  }
}
